import { FC, MouseEvent, useCallback } from 'react';
import { IWebhook } from '../../../../types/webhooks';
import { webhooksStore } from '../../store';
import { localeStore } from 'src/mobx/localesStore';
import { TBooleanInNumber } from 'src/types/main';
import { confirmDelete } from 'src/utils/modalConfirmations';
import Switcher from 'src/view/components/Controls/Switcher/Switcer';
import DeleteRestoreBlock from 'src/view/components/DeleteRestoreBlock/DeleteRestoreBlock';
import { SCREENS } from '~/constants/screens';
import { history } from '~/services/history';
import Text, { TEXT } from '~/view/components/Text/Text';
import './style.scss';

interface IProps {
  webhook: IWebhook;
}

const WebhooksListRow: FC<IProps> = ({ webhook }: IProps): JSX.Element => {
  const onEditWebhook = () => {
    history.push(SCREENS.SETTINGS_WEBHOOK_EDIT(webhook.id));
  };

  const onActionBlockClick = (event: MouseEvent) => {
    event.stopPropagation();
  };

  const onStatusChangeHandler = useCallback(
    (status: TBooleanInNumber) => {
      webhooksStore.changeWebhookStatus(webhook.id, status);
    },
    [webhook]
  );

  const onDeleteHandler = useCallback(() => {
    confirmDelete({
      title: localeStore.t('delete_webhook_title'),
      message: localeStore.t('delete_webhook_message'),
      onConfirm: () => webhooksStore.deleteWebhook(webhook.id),
    });
  }, [webhook]);

  return (
    <div onClick={onEditWebhook} className="webhooks-list-row webhooks-list-row__grid-template mr-4">
      <div className="webhooks-list-row__element">
        <Text type={TEXT.LIST_ROW} text={webhook.name} noTranslate />
      </div>

      <div className="webhooks-list-row__element">
        <Text type={TEXT.LIST_ROW} text={webhook.method} noTranslate className="text-uppercase" />
      </div>

      <div className="webhooks-list-row__element">
        <Text type={TEXT.LIST_ROW} text={webhook.url} noTranslate className="webhooks-list-row__url text-break" />
      </div>

      <div className="webhooks-list-row__element">
        <Text type={TEXT.LIST_ROW} text={webhook.counter} defaultValue="0" noTranslate />
      </div>

      <div onClick={onActionBlockClick} className="webhooks-list-row__element cursor-default gap-20">
        <Switcher status={webhook.status} onChange={onStatusChangeHandler} />
        <DeleteRestoreBlock onDelete={onDeleteHandler} />
      </div>
    </div>
  );
};

export default WebhooksListRow;
